import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function Empresas() {
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [nome, setNome] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [confirmandoExcluir, setConfirmandoExcluir] = useState(null)
  const [editando, setEditando] = useState(null)
  const [editNome, setEditNome] = useState('')

  useEffect(() => { fetchAll() }, [])

  async function fetchAll() {
    setLoading(true)
    const { data } = await supabase.from('companies').select('*').order('nome')
    setCompanies(data || [])
    setLoading(false)
  }

  async function handleCreate(e) {
    e.preventDefault()
    if (!nome.trim()) return
    setSaving(true)
    setError('')
    const { error: err } = await supabase.from('companies').insert({ nome: nome.trim() })
    setSaving(false)
    if (err) { setError(err.message); return }
    setNome('')
    setShowForm(false)
    setSucesso('Empresa criada com sucesso!')
    await fetchAll()
    setTimeout(() => setSucesso(''), 4000)
  }

  async function handleEdit(e) {
    e.preventDefault()
    if (!editNome.trim()) return
    setSaving(true)
    setError('')
    const { error: err } = await supabase.from('companies').update({ nome: editNome.trim() }).eq('id', editando.id)
    setSaving(false)
    if (err) { setError(err.message); return }
    setEditando(null)
    setSucesso('Empresa atualizada.')
    await fetchAll()
    setTimeout(() => setSucesso(''), 4000)
  }

  async function handleDelete(company) {
    await supabase.from('companies').delete().eq('id', company.id)
    setConfirmandoExcluir(null)
    setSucesso(`Empresa ${company.nome} removida.`)
    await fetchAll()
    setTimeout(() => setSucesso(''), 4000)
  }

  return (
    <div>
      <div className="page-title">
        <div>
          <h2>Empresas</h2>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 2 }}>
            Empresas clientes cadastradas na plataforma
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => { setShowForm(s => !s); setError('') }}>
          {showForm ? 'Cancelar' : '+ Nova empresa'}
        </button>
      </div>

      {sucesso && (
        <div className="alert" style={{ background: 'var(--green-bg)', color: 'var(--green)', borderColor: 'var(--green)', borderLeft: '3px solid var(--green)', marginBottom: 16 }}>
          {sucesso}
        </div>
      )}

      {showForm && (
        <div className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ marginBottom: 16 }}>Nova empresa</h3>
          {error && <div className="alert alert-error" style={{ marginBottom: 12 }}>{error}</div>}
          <form onSubmit={handleCreate}>
            <div className="form-group">
              <label>Nome da empresa *</label>
              <input
                value={nome}
                onChange={e => setNome(e.target.value)}
                placeholder="Ex: Acme Corp"
                required
                autoFocus
              />
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Criando...' : 'Criar empresa'}
              </button>
              <button type="button" className="btn" onClick={() => { setShowForm(false); setNome(''); setError('') }}>
                Cancelar
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Modal de edição */}
      {editando && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div className="card" style={{ maxWidth: 360, width: '100%' }}>
            <h3 style={{ marginBottom: 16 }}>Editar empresa</h3>
            {error && <div className="alert alert-error" style={{ marginBottom: 12 }}>{error}</div>}
            <form onSubmit={handleEdit}>
              <div className="form-group">
                <label>Nome *</label>
                <input value={editNome} onChange={e => setEditNome(e.target.value)} required autoFocus />
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
                <button type="button" className="btn" onClick={() => { setEditando(null); setError('') }}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de exclusão */}
      {confirmandoExcluir && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div className="card" style={{ maxWidth: 360, width: '100%', textAlign: 'center' }}>
            <p style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>Excluir empresa?</p>
            <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>
              <strong>{confirmandoExcluir.nome}</strong> e todos os seus dados serão removidos. Esta ação não pode ser desfeita.
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button className="btn btn-sm" style={{ background: 'var(--red)', color: '#fff', borderColor: 'var(--red)' }}
                onClick={() => handleDelete(confirmandoExcluir)}>Sim, excluir</button>
              <button className="btn btn-sm" onClick={() => setConfirmandoExcluir(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="empty-state">Carregando...</div>
      ) : companies.length === 0 ? (
        <div className="empty-state">Nenhuma empresa cadastrada.</div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Cadastrada em</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {companies.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 500 }}>{c.nome}</td>
                  <td style={{ color: 'var(--text2)', fontFamily: 'var(--mono)', fontSize: 12 }}>
                    {new Date(c.created_at).toLocaleDateString('pt-BR')}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-sm btn-ghost" onClick={() => { setEditando(c); setEditNome(c.nome); setError('') }}>
                        Editar
                      </button>
                      <button className="btn btn-sm" style={{ color: 'var(--red)', borderColor: 'var(--red-border)' }}
                        onClick={() => setConfirmandoExcluir(c)}>
                        Excluir
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
